import {gql, useMutation} from "@apollo/client";
import {Carrier_FIELDS, CarrierType} from "../../../../../graphql/types/CarrierType";

export interface CarrierInput {
    id?: string;
    carrierCode: string;
    carrierName: string;
    contactName?: string;
    contactPhone?: string;
    carrierType?: number;
    centerWarehouseIds: string[];
    status: number;
}

export const SAVE_CARRIER = gql`
  mutation SaveCarrier($input: SaveTmsCarrierInput!) {
      saveTmsCarrier(input: $input) {
      ...CarrierFields
    }
  }
  
  ${Carrier_FIELDS}
`;

export interface SaveCarrierResponse {
    saveCarrier: CarrierType;
}

export interface SaveCarrierVariables {
    input: CarrierInput;
}

export const useSaveCarrier = () => {
    return useMutation<SaveCarrierResponse, SaveCarrierVariables>(SAVE_CARRIER);
}; 
